<template>
  <div class="app-container" id="itzb">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="listQuery" :inline="true">
        <el-form-item label="部门" prop="bmmc">
          <el-select
            ref="bmmc"
            v-model="listQuery.bmmc"
            placeholder="所属部门"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="项目名称"
            multiple
            clearable
            collapse-tags
            filterable
            size="small"
            style="width: 290px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="周期" prop="zq">
          <el-select
            ref="zq"
            v-model="listQuery.zq"
            multiple
            clearable
            collapse-tags
            filterable
            size="small"
            style="width: 290px"
            class="filter-item"
          >
            <el-option
              v-for="item in weekData"
              :key="item.key_1"
              :label="item.value_1"
              :value="item.key_1"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="周期" prop="zq">
          <el-date-picker
            v-model="value"
            :clearable="false"
            type="week"
            format="yyyy 第 WW 周"
            placeholder="选择周"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="运维风险级别" prop="sm">
          <el-select
            ref="sm"
            v-model="listQuery.sm"
            placeholder="运维风险级别"
            multiple
            clearable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in smList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="margin-left: 15px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div class="mycontainer">
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        :cell-class-name="myclass"
      >
        <!-- <el-table-column prop="zbbh" label="周报编号" width="80">
        </el-table-column> -->
        <el-table-column prop="xmjc" label="项目名称" width="120">
        </el-table-column>
        <el-table-column prop="bmmc" label="部门" width="100">
        </el-table-column>
        <el-table-column prop="zq" label="周期" width="95"> </el-table-column>
        <el-table-column
          prop="sjkcpsyzb"
          label="数据库磁盘使用占比(%)"
          width="80"
        >
        </el-table-column>
        <el-table-column
          prop="ffqcpsyzb"
          label="应用磁盘使用占比(%)"
          width="80"
        >
        </el-table-column>
        <el-table-column prop="cksjl" label="存款数据量" width="80">
        </el-table-column>
        <el-table-column prop="zdd" label="总调度跑数时间(分)" width="80">
        </el-table-column>
        <el-table-column prop="xtrq" label="系统日期" width="100">
        </el-table-column>
        <el-table-column prop="xtcsts" label="重算天数(天)" width="95">
        </el-table-column>
        <el-table-column prop="lzqkbf" label="两周全库备份" width="80">
        </el-table-column>
        <el-table-column prop="mzgjbbf" label="每周关键表备份" width="80">
        </el-table-column>
        <el-table-column prop="sjkyjjb" label="数据库预警级别" width="100">
        </el-table-column>
        <el-table-column prop="yycpyjjb" label="应用磁盘预警级别" width="100">
        </el-table-column>
        <el-table-column
          prop="zddpsyjjb"
          label="总调度跑数预警级别"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="xtrqyjjb" label="系统日期预警级别" width="100">
        </el-table-column>
        <el-table-column prop="cstsyjjb" label="重算天数预警级别" width="100">
        </el-table-column>
        <el-table-column prop="qkbfyjjb" label="全库备份预警级别" width="100">
        </el-table-column>
        <el-table-column
          prop="gjbbfyjjb"
          label="关键表备份预警级别"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="fx" label="风险指标个数" width="75">
        </el-table-column>
        <!-- <el-table-column prop="xtsyl" label="系统使用率" width="75">
        </el-table-column> -->
        <el-table-column prop="sm" label="运维风险级别" width="75">
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { selectXmzbExport, exportXmzb, getWeekData } from "@/api/itzb.js";
import { getBmxxList, getXmxxList } from "@/api/itWeekly.js";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
export default {
  // 列表分页
  components: { Pagination },

  data() {
    // const rolesAllClass = [{ value: 0, name: '超级管理员' }, { value: 1, name: '普通管理员' }, { value: 2, name: '普通员工' }, { value: 3, name: '普通用户' }]
    return {
      height: 100,
      listQuery: {
        xmbh: [],
        bmbh: "",
        zq: [],
        sm: [],
        page: 1,
        pageSize: 10,
      },
      listLoading: true,
      params: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        xmlx: "0", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        xmzt: null, //合同状态，多个,隔开，如1,3
      },
      value: "",
      time: [],
      total: 0,
      list: [],
      bmList: [],
      xmList: [],
      smList: ["正常", "关注", "预警", "风险"],
      weekData: [],
    };
  },
  created() {
    getBmxxList(this.params.type, this.params.range).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
    getXmxxList(
      this.params.xmlx,
      this.params.range,
      this.params.xmzt,
      this.listQuery.bmbh
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    this.weekCheckingIn();
    getWeekData().then((res) => {
      if (res.code == 0) {
        this.weekData = res.data;
        this.listQuery.zq = [res.data[0].key_1];
        this.getList();
        console.log(this.listQuery)
      }
    });

  },
  methods: {
    myclass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 11) {
        if (row.sjkyjjb == "正常") {
          return "green";
        } else if (row.sjkyjjb == "关注") {
          return "blue";
        } else if (row.sjkyjjb == "预警") {
          return "yellow";
        } else if (row.sjkyjjb == "风险") {
          return "red";
        }
      }
      if (columnIndex == 12) {
        if (row.yycpyjjb == "正常") {
          return "green";
        } else if (row.yycpyjjb == "关注") {
          return "blue";
        } else if (row.yycpyjjb == "预警") {
          return "yellow";
        } else if (row.yycpyjjb == "风险") {
          return "red";
        }
      }
      if (columnIndex == 13) {
        if (row.zddpsyjjb == "正常") {
          return "green";
        } else if (row.zddpsyjjb == "关注") {
          return "blue";
        } else if (row.zddpsyjjb == "预警") {
          return "yellow";
        } else if (row.zddpsyjjb == "风险") {
          return "red";
        }
      }
      if (columnIndex == 14) {
        if (row.xtrqyjjb == "正常") {
          return "green";
        } else if (row.xtrqyjjb == "关注") {
          return "blue";
        } else if (row.xtrqyjjb == "预警") {
          return "yellow";
        } else if (row.xtrqyjjb == "风险") {
          return "red";
        }
      }
      if (columnIndex == 15) {
        if (row.cstsyjjb == "正常") {
          return "green";
        } else if (row.cstsyjjb == "关注") {
          return "blue";
        } else if (row.cstsyjjb == "预警") {
          return "yellow";
        } else if (row.cstsyjjb == "风险") {
          return "red";
        }
      }
      if (columnIndex == 16) {
        if (row.qkbfyjjb == "正常") {
          return "green";
        } else if (row.qkbfyjjb == "关注") {
          return "blue";
        } else if (row.qkbfyjjb == "预警") {
          return "yellow";
        } else if (row.qkbfyjjb == "风险") {
          return "red";
        }
      }
      if (columnIndex == 17) {
        if (row.gjbbfyjjb == "正常") {
          return "green";
        } else if (row.gjbbfyjjb == "关注") {
          return "blue";
        } else if (row.gjbbfyjjb == "预警") {
          return "yellow";
        } else if (row.gjbbfyjjb == "风险") {
          return "red";
        }
      }
      if (columnIndex == 19) {
        if (row.sm == "正常") {
          return "green";
        } else if (row.sm == "关注") {
          return "blue";
        } else if (row.sm == "预警") {
          return "yellow";
        } else if (row.sm == "风险") {
          return "red";
        }
      }
    },
    getList() {
      if (this.listQuery.bmmc) {
        this.listQuery.bmbh = this.listQuery.bmmc;
      }
      const params = { ...this.listQuery };
      params.xmbh = params.xmbh.join(",");
      params.zq = params.zq.join(",");
      params.sm = params.sm.join(",");
      params.bmmc = null;
      selectXmzbExport(params).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 95;
        }
      });
    },
    handleChangeBm(i) {
      this.listQuery.bmbh = i;
      this.listQuery.bmmc = i;
      getXmxxList(
        this.params.xmlx,
        this.params.range,
        this.params.xmzt,
        i
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },
    handleChangeAddBm(i) {
      getXmxxList(
        this.params.xmlx,
        this.params.range,
        this.params.xmzt,
        i
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    weekCheckingIn() {
      var now = new Date();
      var nowTime = now.getTime();
      var day = now.getDay() || 7; // 不加 || 7.周末会变成下周一
      var oneDayTime = 24 * 60 * 60 * 1000;
      var MondayTime = nowTime - (day - 1) * oneDayTime; //显示周一
      var SundayTime = nowTime + (7 - day) * oneDayTime; //显示周日
      //调用方法
      this.value = new Date(MondayTime);
    },
    //导出
    handleExport() {
      const params = { ...this.listQuery };
      params.xmbh = params.xmbh.join(",");
      params.zq = params.zq.join(",");
      params.sm = params.sm.join(",");
      exportXmzb(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
</style>
